import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-min-h-screen tw-bg-gray-50 tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-max-w-md tw-w-full tw-text-center">
        <div className="tw-mb-8">
          <div className="tw-inline-flex tw-items-center tw-justify-center tw-w-24 tw-h-24 tw-bg-red-100 tw-rounded-full tw-mb-4">
            <ShieldX className="tw-w-12 tw-h-12 tw-text-red-600" />
          </div>
          <h1 className="tw-text-6xl tw-font-bold tw-text-gray-900 tw-mb-2">403</h1>
          <h2 className="tw-text-2xl tw-font-semibold tw-text-gray-800 tw-mb-4">
            Accès refusé
          </h2>
          <p className="tw-text-gray-600 tw-mb-8">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
            <br />
            Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.
          </p>
        </div>

        <div className="tw-flex tw-flex-col tw-gap-3 tw-sm:flex-row tw-sm:justify-center">
          <button
            onClick={() => navigate(-1)}
            className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-6 tw-py-3 tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg hover:tw-bg-gray-50 tw-transition-colors"
          >
            <ArrowLeft className="tw-w-5 tw-h-5" />
            Retour
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-6 tw-py-3 tw-text-white tw-bg-affinicar-primary tw-rounded-lg hover:tw-bg-affinicar-secondary tw-transition-colors"
          >
            <Home className="tw-w-5 tw-h-5" />
            Tableau de bord
          </button>
        </div>
      </div>
    </div>
  );
};

